import { SalesforceServiceCloudV2LinkedService } from '../linkedservice/salesforce-service-cloud-v2.linkedservice';
import { format, getConnectorV2Name } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { SalesforceV2Dataset } from './salesforce-v2.dataset';
import { Metamodel } from '../base/model';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';

@Metamodel.model({
    name: ModelConstants.salesforceServiceCloudV2Dataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, getConnectorV2Name(shellStringResources.SalesforceServiceCloudV2Object_DisplayText, isTridentInIframe())),
        format(shellStringResources.ModelName_DatasetsTemplate, getConnectorV2Name(shellStringResources.SalesforceServiceCloudV2Object_DisplayText, isTridentInIframe()))
    ],
    constraints: {
        linkedService: {
            model: SalesforceServiceCloudV2LinkedService.MODEL // Linked service redefined
        }
    }
})
export class SalesforceServiceCloudV2Dataset extends SalesforceV2Dataset { }
